import { makeStyles, tokens } from '@fluentui/react-components';

export const useAppLayoutStyles = makeStyles({
  container: {
    display: 'flex',
    height: 'calc(100vh - 48px)',
    overflow: 'hidden',
  },
  mainContent: {
    flex: '1',
    backgroundColor: tokens.colorNeutralBackground3,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  contentWrapper: {
    maxWidth: '1920px',
    minWidth: 0,
    margin: '0 auto',
    padding: '32px',
    paddingBottom: '80px',
    flex: '1',
    width: '100%',
    boxSizing: 'border-box',
    '@media (max-width: 768px)': {
      padding: '0 0 80px 0',
    },
  },
});
